import React, { useState, useEffect } from 'react';
import { 
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer 
} from 'recharts';
import { 
    ExternalLink, TrendingUp, Filter, Loader2 
} from 'lucide-react';
import api from '../services/api';

const RelatoriosExternosScreen = ({ currentUser }) => { 
    const getLocalYYYYMMDD = (d) => {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    
    const [startDate, setStartDate] = useState(getLocalYYYYMMDD(firstDay));
    const [endDate, setEndDate] = useState(getLocalYYYYMMDD(today));
    
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchReportData = async () => {
        setLoading(true);
        try {
            // MUDANÇA AQUI: Rota específica de Atendimentos Externos
            const response = await api.get('/reports/external', {
                params: { startDate, endDate }
            });
            setReportData(response.data || []);
        } catch (error) {
            console.error("Erro ao gerar relatório:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchReportData(); }, [startDate, endDate]);

    return (
        <div className="p-6 h-full overflow-y-auto bg-gray-50">
            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                <div>
                    <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                        <ExternalLink className="mr-2 text-purple-600" /> Atendimentos Externos
                    </h2>
                    <p className="text-sm text-gray-500">Registros de atendimentos fora do WhatsApp</p>
                </div>

                <div className="flex gap-2 items-center bg-white p-2 rounded-lg shadow-sm border border-gray-200">
                    <Filter className="w-4 h-4 text-gray-500" />
                    <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="p-1.5 border rounded text-sm"/>
                    <span className="text-gray-400">-</span>
                    <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="p-1.5 border rounded text-sm"/>
                    <button onClick={fetchReportData} className="p-1.5 bg-purple-100 text-purple-700 rounded hover:bg-purple-200">
                        {loading ? <Loader2 className="w-4 h-4 animate-spin"/> : <TrendingUp className="w-4 h-4"/>}
                    </button>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <table className="w-full text-sm text-left">
                    <thead className="bg-gray-50 border-b uppercase text-xs text-gray-500">
                        <tr>
                            <th className="px-6 py-3">Cliente</th>
                            <th className="px-6 py-3">Descrição</th>
                            <th className="px-6 py-3 text-center">Data</th>
                            <th className="px-6 py-3 text-center">Responsável</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {reportData.length > 0 ? (
                            reportData.map((item, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 font-bold text-gray-700">{item.clientName}</td>
                                    <td className="px-6 py-4 text-gray-600">{item.description}</td>
                                    <td className="px-6 py-4 text-center text-gray-500">{new Date(item.date).toLocaleDateString()}</td>
                                    <td className="px-6 py-4 text-center text-blue-600">{item.agentName}</td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="4" className="text-center py-8 text-gray-400">Nenhum registro externo.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RelatoriosExternosScreen;